import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate,
} from "@azure/msal-react";
import * as _ from "lodash";
import * as React from "react";
import { msalInstance } from "../../../Api";
import { scopes } from "../../../Configs/msalConfig";
import Loader from "../../General/loader";
import { AxiosError } from "axios";

declare var window: any;

interface IAppLoading {
    errors?: AxiosError<any>;
}

export default function AppLoading(props: IAppLoading) {
    const { errors } = props;

    const canAccess: boolean = !(
        errors &&
        errors.response &&
        errors.response.data &&
        errors.response.data === "No access"
    );

    const serviceAvailable: boolean = !(
        errors &&
        errors.response &&
        errors.response.data &&
        errors.response.data === "Service unavailable"
    );

    const userName =
        msalInstance.getActiveAccount()?.username ?? "Unknown user";

    // appSettings cannot be used because getting settings requires authorized user
    const accessRequestFormUrl =
        "https://fasttrack.service-now.com/mogroup/?id=clear_skye_access_catalog_v3&g=0&c=d49a168a47d525d024eee402e26d43f3";

    return (
        <div className="AppLoading">
            <AuthenticatedTemplate>
                {canAccess && serviceAvailable && (
                    <div>
                        <img
                            className="AppLoading__mainLogo"
                            src="/metso_logo_black.png"
                        />
                        <h2 className="AppLoading__brand">Installed Base</h2>
                        <Loader />
                    </div>
                )}

                {(!canAccess || !serviceAvailable) && (
                    <div className="NoAccess">
                        <div className="NoAccess__brand">
                            <span className="NoAccess__logo">
                                <img src="/metso_logo_black.png" />
                            </span>
                            <span className="NoAccess__brandName">
                                Installed Base
                            </span>
                        </div>
                        <h2 className="NoAccess__heading">
                            {!serviceAvailable
                                ? "Service unavailable"
                                : "No access"}
                        </h2>

                        {!canAccess && serviceAvailable && (
                            <div>
                                <p>
                                    User{" "}
                                    <strong className="me1">{userName}</strong>{" "}
                                    has no access to Installed Base Portal.
                                </p>
                                <p>
                                    <span className="me1">
                                        To request access, please visit Metso
                                        Installed Base
                                    </span>
                                    &nbsp;
                                    <span>
                                        <a href={accessRequestFormUrl}>
                                            access request page
                                        </a>
                                        .
                                    </span>
                                </p>
                                <p>
                                    <a
                                        href="#"
                                        onClick={() =>
                                            msalInstance.loginRedirect({
                                                ...scopes,
                                                prompt: "select_account",
                                            })
                                        }
                                    >
                                        Click here to login with another account
                                    </a>
                                </p>
                            </div>
                        )}

                        {!serviceAvailable && (
                            <div>
                                <p>
                                    Application is starting. Please try to
                                    refresh the page in a few minutes
                                </p>
                                <p>
                                    <button
                                        onClick={() => window.location.reload()}
                                        className="btn mt-2"
                                    >
                                        Refresh
                                    </button>
                                </p>
                            </div>
                        )}
                    </div>
                )}
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <div className="NoAccess">
                    <div className="NoAccess__brand">
                        <span className="NoAccess__logo">
                            <img src="/metso_logo_black.png" />
                        </span>
                        <span className="NoAccess__brandName">
                            Installed Base
                        </span>
                    </div>
                    <h2 className="NoAccess__heading">Login</h2>
                    <div>
                        <p>You are not logged in to Installed Base Portal.</p>
                        <p>
                            <button
                                onClick={() =>
                                    msalInstance.loginRedirect({
                                        ...scopes,
                                        prompt: "select_account",
                                    })
                                }
                                className="btn btn-primary Login__Button"
                            >
                                Login
                            </button>
                        </p>
                        <p>
                            <span className="me1">
                                To request access, please visit Metso Installed
                                Base
                            </span>
                            &nbsp;
                            <span>
                                <a href={accessRequestFormUrl}>
                                    access request page
                                </a>
                                .
                            </span>
                        </p>
                    </div>
                </div>
            </UnauthenticatedTemplate>
        </div>
    );
}
